(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class StickyFiltersComponent {
    constructor(element) {
      this.element = element;
      this.lastScrollTop = this._getScrollTop();
      this.stickyTop = null;
      this.flowTop = 0;
      this.elementHeight = element.offsetHeight;
      /** @type {number} Zichtbare sticky site-header (px). */
      this.headerHeight = 0;
      /** @type {number} Volledige `.facets-controls-wrapper`-rij boven de sidebar (px). */
      this.filtersControlsBarHeight = 0;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleHeightChange = this.handleHeightChange.bind(this);

      this._ticking = false;
      this._resizeTimer = null;
      this._resizeObserver = null;
      this._heightChangeTimer = null;

      this.init();
    }

    /**
     * Offset vanaf viewport-top voor sticky sidebar: site-header + controls-balk (niet alleen h4-titel).
     */
    _updateStickyOffsets() {
      const bodyStyles = getComputedStyle(document.body);
      let headerOffset = parseFloat(bodyStyles.getPropertyValue('--header-height')) || 0;
      headerOffset += parseFloat(bodyStyles.getPropertyValue('--announcement-bar-height-above')) || 0;

      const headerComponent = document.querySelector('header-component');
      if (headerComponent instanceof HTMLElement && headerComponent.hasAttribute('sticky')) {
        const headerSection = headerComponent.closest('.header-section') ?? headerComponent;
        const headerBottom = headerSection.getBoundingClientRect().bottom;
        if (headerBottom > 0) {
          headerOffset = Math.max(headerOffset, headerBottom);
        }
      }

      this.headerHeight = headerOffset;

      const collectionWrapper = this.element.closest('.collection-wrapper');
      const controlsWrapper = collectionWrapper?.querySelector('.facets-controls-wrapper');
      if (controlsWrapper instanceof HTMLElement && controlsWrapper.offsetHeight > 0) {
        this.filtersControlsBarHeight = controlsWrapper.offsetHeight;
        return;
      }

      const filtersTitle = collectionWrapper?.querySelector('.facets--filters-title');
      this.filtersControlsBarHeight =
        filtersTitle instanceof HTMLElement && filtersTitle.offsetHeight ? filtersTitle.offsetHeight : 0;
    }

    _getStickyTopInset() {
      return this.headerHeight + this.filtersControlsBarHeight;
    }

    init() {
      this._updateStickyOffsets();
      this._resetPosition();
      this._measureFlowTop();
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (typeof ResizeObserver !== 'undefined') {
        this._resizeObserver = new ResizeObserver(() => {
          clearTimeout(this._heightChangeTimer);
          this._heightChangeTimer = setTimeout(this.handleHeightChange, 350);
        });
        this._resizeObserver.observe(this.element);
      }

      requestAnimationFrame(() => requestAnimationFrame(this.handleScroll));
    }

    _getScrollTop() {
      // Cross-browser betrouwbaar scrollY
      const el = document.scrollingElement || document.documentElement;
      return typeof window.scrollY === 'number' ? window.scrollY : el.scrollTop || 0;
    }

    _resetPosition() {
      this.stickyTop = null;
      this.element.removeAttribute('data-sticky');
      this.element.style.removeProperty('--facets-sticky-top');
      this.element.style.removeProperty('--facets-relative-top');
      this.element.style.position = '';
      this.element.style.top = '';
      this.element.style.left = '';
      this.element.style.right = '';
      this.element.style.width = '';
    }

    _measureFlowTop() {
      this.flowTop = this._getScrollTop() + this.element.getBoundingClientRect().top;
      this.elementHeight = this.element.offsetHeight;
    }

    _getBottomGap() {
      const value = parseFloat(getComputedStyle(this.element).getPropertyValue('--padding-lg'));
      return Number.isNaN(value) ? 20 : value;
    }

    _setStickyTop(top) {
      const roundedTop = Math.round(top * 2) / 2;
      if (this.stickyTop === roundedTop && this.element.getAttribute('data-sticky') === 'true') return;

      this.stickyTop = roundedTop;
      this.element.setAttribute('data-sticky', 'true');
      this.element.style.setProperty('--facets-sticky-top', `${roundedTop}px`);
    }

    handleScroll() {
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        this._ticking = false;

        if (window.innerWidth < 750) {
          this._resetPosition();
          return;
        }

        const previousTopInset = this._getStickyTopInset();
        this._updateStickyOffsets();
        const stickyTopInset = this._getStickyTopInset();
        const scrollTop = this._getScrollTop();
        const scrollDelta = scrollTop - this.lastScrollTop;
        this.lastScrollTop = scrollTop;
        const naturalTop = this.flowTop - scrollTop;

        // Laat de sidebar in de normale grid-flow totdat hij de sticky bovengrens bereikt.
        if (naturalTop >= stickyTopInset) {
          this._resetPosition();
          return;
        }

        const elementHeight = this.element.offsetHeight;
        const bottomTop = window.innerHeight - elementHeight - this._getBottomGap();

        // Een korte sidebar past volledig tussen header en viewport-onderkant.
        if (bottomTop >= stickyTopInset) {
          this._setStickyTop(stickyTopInset);
          return;
        }

        if (this.stickyTop === null) {
          // Laat een lange sidebar eerst volledig in de normale document-flow
          // meelopen. Pas wanneer de onderkant de viewport bereikt, is sticky
          // positionering nodig. Dit voorkomt top-updates op iedere scrollpixel.
          if (naturalTop > bottomTop) return;

          this._setStickyTop(bottomTop);
          return;
        }

        const wasPinnedToTop = this.stickyTop >= previousTopInset - 1;
        if (scrollDelta < 0 && wasPinnedToTop) {
          this._setStickyTop(stickyTopInset);
          return;
        }

        // De topwaarde beweegt tegengesteld aan de scrollrichting. Zo blijft de
        // sidebar bij een richtingswissel eerst staan en schuift hij daarna naar
        // de relevante viewportgrens, zonder ooit uit de grid-flow te verdwijnen.
        const nextTop = this.stickyTop - scrollDelta;
        this._setStickyTop(Math.max(bottomTop, Math.min(stickyTopInset, nextTop)));
      });
    }

    handleResize() {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => {
        this._resetPosition();
        this.lastScrollTop = this._getScrollTop();
        this._updateStickyOffsets();
        this._measureFlowTop();
        this.handleScroll();
      }, 120);
    }

    handleHeightChange() {
      if (window.innerWidth < 750) return;
      const previousBottomTop = window.innerHeight - this.elementHeight - this._getBottomGap();
      const wasPinnedToBottom = this.stickyTop !== null && this.stickyTop <= previousBottomTop + 1;

      this.elementHeight = this.element.offsetHeight;
      if (wasPinnedToBottom) {
        this._setStickyTop(window.innerHeight - this.elementHeight - this._getBottomGap());
      }

      this.lastScrollTop = this._getScrollTop();
      this.handleScroll();
    }

    destroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }

      if (this._heightChangeTimer) {
        clearTimeout(this._heightChangeTimer);
        this._heightChangeTimer = null;
      }

      this._resetPosition();
    }
  }

  // Initialize voor alle verticale filter wrappers
  const initializeStickyFilters = () => {
    const filterWrappers = document.querySelectorAll('.facets-block-wrapper--vertical:not(#filters-drawer)');
    const instances = new Map();

    filterWrappers.forEach((wrapper) => {
      if (!instances.has(wrapper)) {
        instances.set(wrapper, new StickyFiltersComponent(wrapper));
      }
    });

    return instances;
  };

  let stickyInstances = new Map();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      stickyInstances = initializeStickyFilters();
    });
  } else {
    stickyInstances = initializeStickyFilters();
  }

  // Cleanup bij page unload
  window.addEventListener('beforeunload', () => {
    stickyInstances.forEach((instance) => instance.destroy());
  });

  // Re-initialize na section updates (bij filter changes)
  document.addEventListener('shopify:section:load', () => {
    stickyInstances.forEach((instance) => instance.destroy());
    stickyInstances = initializeStickyFilters();
  });

  document.addEventListener('hds:reinitialize-sticky-facets', () => {
    stickyInstances.forEach((instance) => instance.destroy());
    stickyInstances = initializeStickyFilters();
    reEvaluateStickyFilters();
  });

  // Mobile sticky facets toggle component
  class MobileStickyFacetsToggle {
    constructor(element) {
      this.element = element;
      this.resultsList = document.querySelector('results-list');
      
      this.facetsToggleTop = 0;
      this.resultsListBottom = 0;
      // Spacer is een sibling van het element, niet een child
      // Zoek de spacer door naar het parent element te gaan en dan te zoeken
      const parent = this.element.parentElement;
      this.spacer = parent ? parent.querySelector('.facets-toggle-spacer') : null;
      this.elementHeight = 0;
      
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      
      // debounce voor resize
      this._resizeTimer = null;
      
      this.init();
    }

    init() {
      if (window.innerWidth >= 750) return;

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      // Forceer een eerste evaluatie
      this.updatePositions();
      this.handleScroll();
    }

    updatePositions() {
      const rect = this.element.getBoundingClientRect();
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      this.facetsToggleTop = scrollTop + rect.top;
      this.elementHeight = rect.height;

      if (this.resultsList) {
        const resultsRect = this.resultsList.getBoundingClientRect();
        this.resultsListBottom = scrollTop + resultsRect.top + resultsRect.height;
      }
    }

    updateSpacer() {
      // CSS sticky blijft in-flow; een spacer-hoogte maakt een witte gap boven de chips.
      if (this.spacer) {
        this.spacer.style.height = '0px';
      }
    }

    handleScroll() {
      if (window.innerWidth >= 750) {
        this.element.classList.remove('facets-toggle--sticky');
        return;
      }

      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      
      // Update positions als nodig
      if (!this.facetsToggleTop || !this.resultsListBottom) {
        this.updatePositions();
      }

      const isPastFacetsToggle = scrollTop >= this.facetsToggleTop;
      const isPastResultsList = this.resultsList && scrollTop >= this.resultsListBottom;

      const shouldBeSticky = isPastFacetsToggle && !isPastResultsList;
      const isCurrentlySticky = this.element.classList.contains('facets-toggle--sticky');

      // Update spacer height altijd op basis van shouldBeSticky, niet op basis van huidige state
      // Dit voorkomt verspringing omdat de spacer altijd de juiste hoogte heeft
      this.updateSpacer(shouldBeSticky);

      if (shouldBeSticky !== isCurrentlySticky) {
        if (shouldBeSticky) {
          // Update element height before making sticky
          if (!isCurrentlySticky) {
            this.updatePositions();
            // Update spacer met nieuwe hoogte
            this.updateSpacer(true);
          }
          this.element.classList.add('facets-toggle--sticky');
        } else {
          this.element.classList.remove('facets-toggle--sticky');
        }
      }
    }

    handleResize() {
      // Debounce om fladderen bij slepen/resizen te voorkomen
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => {
        if (window.innerWidth >= 750) {
          this.element.classList.remove('facets-toggle--sticky');
          return;
        }

        this.updatePositions();
        this.updateSpacer();
        this.handleScroll();
      }, 120);
    }

    destroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.element.classList.remove('facets-toggle--sticky');
      if (this.spacer) {
        this.spacer.style.height = '0px';
      }
    }
  }

  // Initialize mobile sticky facets toggle
  const initializeMobileStickyFacetsToggle = () => {
    const facetsToggle = document.querySelector('.facets-toggle');
    if (!facetsToggle) return null;

    return new MobileStickyFacetsToggle(facetsToggle);
  };

  let mobileStickyInstance = null;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      mobileStickyInstance = initializeMobileStickyFacetsToggle();
    });
  } else {
    mobileStickyInstance = initializeMobileStickyFacetsToggle();
  }

  // Cleanup bij page unload
  window.addEventListener('beforeunload', () => {
    if (mobileStickyInstance) {
      mobileStickyInstance.destroy();
    }
  });

  // Re-initialize na section updates (bij filter changes)
  document.addEventListener('shopify:section:load', () => {
    if (mobileStickyInstance) {
      mobileStickyInstance.destroy();
    }
    mobileStickyInstance = initializeMobileStickyFacetsToggle();
  });

  document.addEventListener('hds:reinitialize-sticky-facets', () => {
    if (mobileStickyInstance) {
      mobileStickyInstance.destroy();
    }
    mobileStickyInstance = initializeMobileStickyFacetsToggle();
    reEvaluateStickyFilters();
  });

  // Helper functie om sticky filters opnieuw te evalueren
  const reEvaluateStickyFilters = () => {
    // Wacht tot de browser de scroll positie heeft hersteld
    // Gebruik requestAnimationFrame om te wachten tot de volgende frame
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Bij resize van mobiel naar desktop: re-initialize desktop instances
        if (window.innerWidth >= 750 && stickyInstances.size === 0) {
          stickyInstances = initializeStickyFilters();
        }

        // Bij resize van desktop naar mobiel: destroy desktop instances
        if (window.innerWidth < 750 && stickyInstances.size > 0) {
          stickyInstances.forEach((instance) => instance.destroy());
          stickyInstances.clear();
        }

        // Reset en herbereken sticky filters voor desktop
        stickyInstances.forEach((instance, element) => {
          if (instance && instance.element) {
            instance._resetPosition();
            instance.lastScrollTop = instance._getScrollTop();
            instance._updateStickyOffsets();
            instance._measureFlowTop();

            // Forceer herberekening
            instance.handleScroll();
          }
        });

        // Reset en herbereken mobile sticky toggle
        if (window.innerWidth < 750) {
          // Re-initialize mobile instance als deze niet bestaat
          if (!mobileStickyInstance) {
            mobileStickyInstance = initializeMobileStickyFacetsToggle();
          }

          if (mobileStickyInstance) {
            mobileStickyInstance.updatePositions();
            mobileStickyInstance.handleScroll();
          }
        } else {
          // Destroy mobile instance als we naar desktop gaan
          if (mobileStickyInstance) {
            mobileStickyInstance.destroy();
            mobileStickyInstance = null;
          }
        }
      });
    });
  };

  // Re-initialize na popstate (browser back/forward)
  // Registreer direct, niet binnen een if statement
  (function() {
    let lastWindowWidth = window.innerWidth;
    
    window.addEventListener('popstate', () => {
      lastWindowWidth = window.innerWidth;
      reEvaluateStickyFilters();
    });

    // Backup: re-evaluate na pageshow (voor volledige page loads vanuit cache)
    window.addEventListener('pageshow', (event) => {
      // event.persisted is true wanneer de pagina vanuit de bfcache komt
      if (event.persisted) {
        lastWindowWidth = window.innerWidth;
        reEvaluateStickyFilters();
      }
    });

    // Re-evaluate bij resize (voor breedte wijzigingen tussen mobiel/desktop)
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const currentWidth = window.innerWidth;
        const wasMobile = lastWindowWidth < 750;
        const isMobile = currentWidth < 750;
        
        // Alleen re-evaluate als we switchen tussen mobiel en desktop
        if (wasMobile !== isMobile) {
          lastWindowWidth = currentWidth;
          reEvaluateStickyFilters();
        }
      }, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["popup-link"] && !Shopify.designMode) return;
  try {
    // Detect scroll in popup-link drawers and add background to sticky title
  document.addEventListener('DOMContentLoaded', () => {
    const handleDrawerScroll = (inner) => {
      const firstChild = inner.firstElementChild;
      if (!firstChild) return;
      
      // Check if first child is a heading
      const isHeading = firstChild.matches('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6') ||
                        firstChild.querySelector('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6');
      
      if (isHeading) {
        const updateScrollState = () => {
          if (inner.scrollTop > 0) {
            inner.classList.add('is-scrolled');
          } else {
            inner.classList.remove('is-scrolled');
          }
        };
        
        inner.addEventListener('scroll', updateScrollState, { passive: true });
        updateScrollState(); // Check initial state
      }
    };
    
    // Handle existing drawers
    document.querySelectorAll('.popup-link__content--drawer .popup-link__inner').forEach(handleDrawerScroll);
    
    // Handle dynamically opened drawers
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            const inner = node.querySelector?.('.popup-link__content--drawer .popup-link__inner') ||
                         (node.matches?.('.popup-link__content--drawer .popup-link__inner') ? node : null);
            if (inner) {
              handleDrawerScroll(inner);
            }
          }
        });
      });
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-review-stars"] && !Shopify.designMode) return;
  try {
    // Inline star rendering utilities
  function snapRating(rating) {
    const wholePart = Math.floor(rating);
    const decimalPart = rating - wholePart;
    
    let snappedDecimal;
    
    if (decimalPart <= 0.125) {
      snappedDecimal = 0;
    } else if (decimalPart <= 0.375) {
      snappedDecimal = 0.25;
    } else if (decimalPart <= 0.5) {
      snappedDecimal = 0.5;
    } else if (decimalPart <= 0.75) {
      snappedDecimal = 0.5;
    } else if (decimalPart <= 0.875) {
      snappedDecimal = 0.75;
    } else {
      snappedDecimal = 0.75;
    }
    
    return wholePart + snappedDecimal;
  }

  function createStarSVG(isFull, fillPercentage, starColor, emptyColor) {
    const starId = `star-${Math.random().toString(36).substr(2, 9)}`;
    
    return `
      <svg width="20" height="20" viewBox="0 0 24 24" class="star-svg">
        <defs>
          <linearGradient id="${starId}" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style="stop-color:${starColor};stop-opacity:1" />
            <stop offset="${fillPercentage}%" style="stop-color:${starColor};stop-opacity:1" />
            <stop offset="${fillPercentage}%" style="stop-color:${emptyColor};stop-opacity:1" />
            <stop offset="100%" style="stop-color:${emptyColor};stop-opacity:1" />
          </linearGradient>
        </defs>
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="url(#${starId})" />
      </svg>
    `;
  }

  function renderStarsHTML(average, starColor, emptyColor) {
    const snappedRating = snapRating(average);
    let starsHTML = '';
    
    for (let i = 1; i <= 5; i++) {
      if (snappedRating >= i) {
        starsHTML += createStarSVG(true, 100, starColor, emptyColor);
      } else if (snappedRating > i - 1) {
        const fillPercentage = Math.round(((snappedRating - (i - 1)) * 100));
        starsHTML += createStarSVG(false, fillPercentage, starColor, emptyColor);
      } else {
        starsHTML += createStarSVG(false, 0, starColor, emptyColor);
      }
    }
    
    return starsHTML;
  }

  function ldJsonTypeNames(node) {
    const t = node && node['@type'];
    if (t == null) return [];
    return Array.isArray(t) ? t : [t];
  }

  function ldJsonIsProductGroup(node) {
    return ldJsonTypeNames(node).includes('ProductGroup');
  }

  function ldJsonIsProduct(node) {
    return ldJsonTypeNames(node).includes('Product');
  }

  function ldJsonHasUsableAggregateRating(node) {
    const ar = node && node.aggregateRating;
    if (!ar || typeof ar !== 'object') return false;
    const rv = ar.ratingValue;
    if (rv == null || rv === '') return false;
    const n = Number(rv);
    return Number.isFinite(n) && n > 0;
  }

  function ldJsonFindProductRoot(node) {
    if (!node || typeof node !== 'object') return null;
    if (Array.isArray(node['@graph'])) {
      const graph = node['@graph'];
      const group = graph.find(ldJsonIsProductGroup);
      if (group) return group;
      const product = graph.find(ldJsonIsProduct);
      return product || null;
    }
    if (ldJsonIsProductGroup(node)) return node;
    if (ldJsonIsProduct(node)) return node;
    return null;
  }

  function ldJsonFindMergeTarget(parsed) {
    if (Array.isArray(parsed)) {
      for (let i = 0; i < parsed.length; i++) {
        const found = ldJsonFindProductRoot(parsed[i]);
        if (found) return found;
      }
      return null;
    }
    return ldJsonFindProductRoot(parsed);
  }

  function mergeYotpoAggregateRatingIntoLdJson(average, count) {
    if (typeof window === 'undefined') return;
    if (window.__hdsYotpoAggregateRatingMerged) return;

    const ratingValue = Math.round(Number(average) * 100) / 100;
    if (!Number.isFinite(ratingValue) || ratingValue <= 0) return;

    const reviewCount = Math.floor(Number(count));
    const rc = Number.isFinite(reviewCount) && reviewCount > 0 ? reviewCount : null;

    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (let s = 0; s < scripts.length; s++) {
      const script = scripts[s];
      let parsed;
      try {
        parsed = JSON.parse(script.textContent.trim());
      } catch {
        continue;
      }

      const target = ldJsonFindMergeTarget(parsed);
      if (!target || ldJsonHasUsableAggregateRating(target)) continue;

      const aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue,
        bestRating: 5,
        worstRating: 1
      };
      if (rc != null) aggregateRating.reviewCount = rc;

      target.aggregateRating = aggregateRating;
      script.textContent = JSON.stringify(parsed);
      window.__hdsYotpoAggregateRatingMerged = true;
      return;
    }
  }

  class ProductReviewStars {
    constructor(element) {
      this.element = element;
      this._clickBound = false;
    }

    async init() {
      try {
        // Laad provider
        await this.loadProvider();
        
        // Resolve product ID
        const productId = await this.resolveProductId();
        
        if (!productId) {
          this.handleFailure('Product ID kon niet worden bepaald');
          this.setupClickHandler();
          return;
        }
        
        // Laad bottomline data
        await this.loadBottomlineData(productId);
        
        this.setupClickHandler();
      } catch (error) {
        this.handleFailure('ProductReviewStars init mislukt', error);
        this.setupClickHandler();
      }
    }

    async reloadFromDom() {
      window.__hdsYotpoAggregateRatingMerged = false;
      try {
        await this.loadProvider();
        const productId = await this.resolveProductId();
        if (!productId) {
          this.handleFailure('Product ID kon niet worden bepaald');
          return;
        }
        await this.loadBottomlineData(productId);
      } catch (error) {
        this.handleFailure('ProductReviewStars reloadFromDom mislukt', error);
      }
    }
    
          async loadProvider() {
            const providerName = this.element.dataset.providerName;
            
            // Wacht tot de provider registry geladen is
            let attempts = 0;
            while (!window.getProvider && attempts < 50) {
              await new Promise(resolve => setTimeout(resolve, 100));
              attempts++;
            }
            
            if (!window.getProvider) {
              throw new Error('Provider registry niet geladen');
            }
            
            const baseProvider = await window.getProvider(providerName);
            
            // Maak een kopie van het provider object om extensible te maken
            this.provider = { ...baseProvider };
            
            if (providerName === 'yotpo') {
              const appKey = this.element.dataset.yotpoAppKey;
              if (!appKey) {
                throw new Error('Yotpo App Key is vereist');
              }
              this.provider.appKey = appKey;
            }
          }
    
    async resolveProductId() {
      const mode = this.element.dataset.productIdMode || 'auto';
      const customId = this.element.dataset.productIdCustom;
      
      if (mode === 'custom') {
        return customId || null;
      }
      
      const productData = this.getProductData();
      
      if (mode === 'shopify_id') {
        return productData?.id?.toString() || null;
      }
      
      if (mode === 'handle') {
        return productData?.handle || null;
      }
      
      // Auto mode: probeer in volgorde
      const candidates = [
        customId,
        productData?.id?.toString(),
        productData?.handle
      ].filter(Boolean);
      
      return candidates[0] || null;
    }
    
    getProductData() {
      const picker = document.querySelector('variant-picker[data-product-id]');
      if (picker?.dataset?.productId) {
        return { id: String(picker.dataset.productId) };
      }

      const sticky = document.querySelector('sticky-add-to-cart[data-product-id]');
      if (sticky?.dataset?.productId) {
        return { id: String(sticky.dataset.productId) };
      }

      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      for (let i = 0; i < scripts.length; i++) {
        try {
          const parsed = JSON.parse(scripts[i].textContent.trim());
          const target = ldJsonFindMergeTarget(parsed);
          if (!target) continue;

          if (ldJsonIsProductGroup(target) && target.productGroupID != null && target.productGroupID !== '') {
            const handle =
              typeof target.url === 'string' ? target.url.match(/\/products\/([^/?]+)/)?.[1] : null;
            return { id: String(target.productGroupID), ...(handle ? { handle } : {}) };
          }

          if (ldJsonIsProduct(target) && target.sku) {
            const handle =
              typeof target.url === 'string' ? target.url.match(/\/products\/([^/?]+)/)?.[1] : null;
            return { id: String(target.sku), ...(handle ? { handle } : {}) };
          }

          if (ldJsonIsProduct(target) && typeof target.url === 'string') {
            const handle = target.url.match(/\/products\/([^/?]+)/)?.[1];
            if (handle) return { handle };
          }
        } catch {
          continue;
        }
      }

      const productIdMeta = document.querySelector('meta[name="product-id"]');
      const productHandleMeta = document.querySelector('meta[name="product-handle"]');
      if (productIdMeta || productHandleMeta) {
        return {
          id: productIdMeta?.content,
          handle: productHandleMeta?.content
        };
      }

      const urlMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
      if (urlMatch) {
        return { handle: urlMatch[1] };
      }

      if (window.Shopify?.product) {
        return window.Shopify.product;
      }

      return null;
    }
    
    async loadBottomlineData(productId) {
      try {
        // Probeer eerst bottomline API (snelste route)
        const bottomlineOptions = {
          productId: productId,
          appKey: this.provider.appKey,
          debug: this.isDebugMode()
        };
        
        const bottomlineSummary = await this.provider.fetchSummary(bottomlineOptions);
        
        if (bottomlineSummary && bottomlineSummary.average > 0) {
          this.renderStars(bottomlineSummary);
          return;
        }

        const reviewsOptions = {
          productId: productId,
          perPage: 1, // Alleen eerste review nodig voor summary
          page: 1,
          sort: 'date',
          direction: 'desc',
          appKey: this.provider.appKey,
          debug: this.isDebugMode()
        };
        
        const reviewsData = await this.provider.fetchReviews(reviewsOptions);
        
        if (reviewsData?.summary?.average > 0) {
          this.renderStars(reviewsData.summary);
        } else {
          this.renderStars({ average: 0, count: 0 });
        }
        
      } catch (error) {
        this.handleFailure('Fout bij laden van review data', error);
      }
    }
    
    renderStars(data) {
      const container = this.element.querySelector('.review-stars-container');
      if (!container) return;
      
      const average = data.average || 0;
      const count = data.count || 0;
      
      // Haal kleuren uit data-attributen
      const starColor = this.element.dataset.starColor || '#b8915c';
      const emptyColor = this.element.dataset.starEmptyColor || '#d1d1d1';
      
      let contentHTML = '';
      
      // Sterren
      contentHTML += '<div class="review-stars-stars">';
      contentHTML += renderStarsHTML(average, starColor, emptyColor);
      contentHTML += '</div>';
      
      // Gemiddelde score alleen tonen als er reviews zijn
      if (this.element.dataset.showAverageScore === 'true' && count > 0) {
        const formattedScore = average.toFixed(1).replace('.', ',');
        contentHTML += `<span class="review-stars-text">${formattedScore}/5</span>`;
      }
      
      // Aantal reviews
      if (this.element.dataset.showReviewCount === 'true' && count > 0) {
        const countText = count === 1 ? 'review' : 'reviews';
        contentHTML += `<span class="review-stars-count">(${count} ${countText})</span>`;
      }
      
      container.innerHTML = `<div class="review-stars-content">${contentHTML}</div>`;
      container.setAttribute('aria-busy', 'false');

      if (average > 0) {
        mergeYotpoAggregateRatingIntoLdJson(average, count);
      }
    }
    
    setupClickHandler() {
      if (this._clickBound) return;
      this._clickBound = true;

      this.element.addEventListener('click', () => {
        this.scrollToTarget();
      });

      this.element.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.scrollToTarget();
        }
      });
    }
    
    scrollToTarget() {
      const target = this.element.dataset.scrollTarget;
      
      if (!target) {
        return;
      }
      
      const targetElement = document.querySelector(target);
      
      if (targetElement) {
        targetElement.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    
    handleFailure(message, error) {
      if (error !== undefined) {
        console.error('[ProductReviewStars]', message, error);
      } else {
        console.error('[ProductReviewStars]', message);
      }
      this.renderStars({ average: 0, count: 0 });
    }
    
    isDebugMode() {
      return this.element.dataset.debugMode === 'true';
    }
  }

  function bootProductReviewStars() {
    document.querySelectorAll('.product-review-stars').forEach((element) => {
      let inst = element.__hdsProductReviewStars;
      if (!inst) {
        inst = new ProductReviewStars(element);
        element.__hdsProductReviewStars = inst;
      }
      void inst.init();
    });
  }

  document.addEventListener('DOMContentLoaded', bootProductReviewStars);

  document.addEventListener('variant:update', (e) => {
    if (!e.detail?.data?.newProduct) return;
    document.querySelectorAll('.product-review-stars').forEach((element) => {
      let inst = element.__hdsProductReviewStars;
      if (!inst) {
        inst = new ProductReviewStars(element);
        element.__hdsProductReviewStars = inst;
      }
      void inst.reloadFromDom();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
